import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import QuemSomos from "@/pages/QuemSomos";
import Metodo4D from "@/pages/Metodo4D";
import Conteudo from "@/pages/Conteudo";
import Artigo from "@/pages/Artigo";
import Contato from "@/pages/Contato";
import Admin from "@/pages/Admin";
import AnalyticsPageViews from "@/AnalyticsPageViews";
import Diagnostico from "@/pages/Diagnostico";
import Plataforma from "@/pages/Plataforma";
import Portal from "@/pages/Portal";
import DefinirSenha from "@/pages/DefinirSenha";
import Agendar from "@/pages/Agendar";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsPageViews />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quem-somos" element={<QuemSomos />} />
            <Route path="/metodo-4d" element={<Metodo4D />} />
            <Route path="/conteudo" element={<Conteudo />} />
            <Route path="/conteudo/:slug" element={<Artigo />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/diagnostico" element={<Diagnostico />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/definir-senha" element={<DefinirSenha />} />
            <Route path="/agendar" element={<Agendar />} />
            <Route path="/plataforma-4d" element={<Plataforma />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
